import { render, staticRenderFns } from "./ProductAvailability.vue?vue&type=template&id=42dcec08&scoped=true"
import script from "./ProductAvailability.vue?vue&type=script&lang=js"
export * from "./ProductAvailability.vue?vue&type=script&lang=js"
import style0 from "./ProductAvailability.vue?vue&type=style&index=0&id=42dcec08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dcec08",
  null
  
)

export default component.exports